import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { ClockIcon } from 'lucide-react';
export function UrgencySection() {
  const {
    formattedTime
  } = useCountdown();
  return <section className="py-12 px-4 bg-brand-red text-white text-center" data-id="element-193">
      <div className="max-w-2xl mx-auto" data-id="element-194">
        <div className="flex justify-center mb-4" data-id="element-195">
          <ClockIcon className="w-12 h-12 animate-pulse" data-id="element-196" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-197">
          ¡Atención! Esta oferta especial y los bonos gratuitos desaparecen en:
        </h2>
        <div className="text-5xl md:text-7xl font-bold tracking-widest font-inter bg-black/20 inline-block px-6 py-4 rounded-2xl shadow-inner" data-id="element-198">
          {formattedTime}
        </div>
      </div>
    </section>;
}